module.exports = __webpack_public_path__ + "static/amazon-logo-00a57209589784173f59013bd36f4fbf.png";